import React, { useEffect, useState } from "react";
import { Button, Drawer } from "antd";
import TierCards from "./TierCards";
import SheetHeaderClose from "./SheetHeaderClose";

interface Props {
  open: boolean;
  onClose: () => void;
  value: string[];
  onApply: (value: string[]) => void;
}

export default function TierPickerSheet({ open, onClose, value, onApply }: Props) {
  const [draft, setDraft] = useState<string[]>(value);

  useEffect(() => {
    if (open) setDraft(value);
  }, [open, value]);

  const apply = () => {
    onApply(draft);
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="bottom"
      height="auto"
      title="Tour Standard"
      closable={false}
      extra={<SheetHeaderClose onClose={onClose} />}
      rootClassName="v2-sheet v2-sheet--tier"
      footer={
        <div className="v2-filters__footer">
          <Button type="text" className="v2-filters__clear" onClick={() => setDraft([])}>
            Clear All
          </Button>
          <Button type="primary" className="v2-filters__apply" onClick={apply}>
            Apply
          </Button>
        </div>
      }
    >
      <p className="v2-sheet__lede">Please choose your preferred tour standard.</p>
      <TierCards
        selected={draft}
        onToggle={(tier) =>
          setDraft(draft.includes(tier) ? draft.filter((item) => item !== tier) : [...draft, tier])
        }
      />
    </Drawer>
  );
}
